export const HOSTAPP_WEB_PLATFORM_MODULE = 'webPlatform_module';
